import PlansVM from './plans-vm';
export default {
  init(node) {
    console.log('ShopPlan Override init - webpack');

    const data = JSON.parse($('#plans-json').val());
    const vm = new PlansVM(data);
    vm.currentSplitView(node.dataset.currentSplitView);
    ko.applyBindingsWithValidation(vm, node, Kadenze.DEFAULT_VALIDATION_OPTIONS);
  }
};

